// extracted by mini-css-extract-plugin
module.exports = {"ra-blog-author":"ra-blog-author_ra-blog-author__ANV2y","ra-blog-author__column":"ra-blog-author_ra-blog-author__column__Xkic4"};